import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import {
  IconButton,
  Icons,
  Typography,
  useTheme,
  Badge,
} from '@ublend-npm/aulaui-core';
import React from 'react';
import AllConversationsView from './common/AllConversationsView';

interface AllConversationsDialogViewProps {
  handleConversationClick: (
    conversationId: string,
    isFromModal?: boolean
  ) => void;
  isAllConversationsDialogOpen: boolean;
  handleAllConversationsDialogClose: () => void;
  totalUnreadCount: number;
}

const AllConversationsDialogView: React.FC<AllConversationsDialogViewProps> = ({
  handleConversationClick,
  isAllConversationsDialogOpen,
  handleAllConversationsDialogClose,
  totalUnreadCount,
}) => {
  const { palette } = useTheme();

  const onConversationClick = (id: string) => {
    handleConversationClick(id, true);
  };

  return (
    <Dialog
      open={isAllConversationsDialogOpen}
      onClose={handleAllConversationsDialogClose}
      fullWidth
      aria-labelledby="all-conversations-dialog-title"
      aria-describedby="all-conversations-dialog-description"
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: palette.background.paper,
          color: palette.text.primary,
        },
      }}
      PaperProps={{
        sx: {
          maxWidth: '648px',
        },
      }}
    >
      <DialogTitle id="all-conversations-dialog-title" sx={{ padding: 2 }}>
        <Typography
          variant="subtitle1"
          component="h2"
          fontWeight="medium"
          color="primary"
          sx={{ display: 'inline-block' }}
        >
          Messages
        </Typography>

        {totalUnreadCount > 0 ? (
          <Badge
            badgeContent={totalUnreadCount}
            role="status"
            aria-live="polite"
            aria-label={`You have ${totalUnreadCount} unread messages`}
            color="primary"
            sx={{ marginLeft: 2 }}
          />
        ) : null}
        <IconButton
          onClick={handleAllConversationsDialogClose}
          aria-label="Close"
          size="small"
          sx={{
            float: 'right',
          }}
        >
          <Icons.Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 2, paddingTop: 0 }}>
        <AllConversationsView handleConversationClick={onConversationClick} />
      </DialogContent>
    </Dialog>
  );
};

export default AllConversationsDialogView;
